module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI1IDI1Ij4KICAgIDxnIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjMxIiBoZWlnaHQ9IjMuMjUiIHg9Ii0zIiB5PSIxMSIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDEyLjUgMTIuNjI1KSIvPgogICAgICAgIDxyZWN0IHdpZHRoPSIzMSIgaGVpZ2h0PSIzLjI1IiB4PSItMyIgeT0iMTEuNDI4IiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDEyLjUgMTMuMDUzKSIvPgogICAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x-icon.svg
// module id = 210
// module chunks = 2